import * as React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ShowCompanyDropdown from '@applications/channel-care/components/company-dropdown';
import { Data, ProfileIdentifier } from '@telstra-connect/utils';
import { LoginState } from '@applications/sign-in';
import { ILoadCompanyRequest } from '@telstra-connect/channel-care/state/company';
import { ICustomerProfileClientState, ICustomerProfileRequest } from '@telstra-connect/channel-care/state/token-state';
import { IChannelCareAppState, ILoadCasesRequest, ISelectedFilters } from '@telstra-connect/channel-care/state';
import { IUserManagementClientState } from '@telstra-connect/channel-care/state/user-management-state';
import { Application } from '@channel-care';
import { Components, Links } from '@telstra-connect/channel-care/activity-tracking';
import { requestFinished } from '@telstra-connect/utils/data';
import Column from '@able/react/dist/Column';
import Spacing from '@able/react/dist/Spacing';
import { loadCasesFilterUplift, updateSelectedFilters } from '@telstra-connect/channel-care/methods/view-cases-uplift';
import {setSelectedCidnGlobally} from "@redux/actions";

type SubscribedState = IChannelCareAppState & LoginState.ISignInState
& ICustomerProfileClientState & IUserManagementClientState

interface ICasesComponentStateProps {
    cases: ILoadCasesRequest,
    companyMultiCidn: ILoadCompanyRequest;
    customerProfile?: ICustomerProfileRequest;
    signInState?: LoginState.ISignInState
}
interface IListCasesOwnProps {
    updateCompanyid: (selectedCompanyId: string) => void,
    updatedCompanyId: string,
    showUpliftedDropdown?: boolean;
    resetSubmittedByOnChange?: boolean;
    addColumnAndSpacing?: boolean;
}

export const NewCompanyDropdown = (props: IListCasesOwnProps) => {
    const dispatch = useDispatch()
    const [selectedCompanyId, setSelectedCompanyId] =  useState(props.updatedCompanyId);
    const filtersFromState = useSelector(
        (state: IChannelCareAppState) => state.channelCare.selectedFilters
    );
    const { companyMultiCidn, customerProfile, signInState }
    = useSelector((state: SubscribedState): ICasesComponentStateProps => ({
        cases: state.channelCare.cases,
        companyMultiCidn: state.channelCare.companyMultiCidn,
        customerProfile: state.tokens.customerProfile,
        signInState: state
    }));
    const isStaffUser = ProfileIdentifier.checkIfStaffUser(signInState) ||
    customerProfile?.data?.profile === Data.UserType.staffUser;
    const isCompanyDropDownShow = companyMultiCidn?.data?.data?.length > 1 && !isStaffUser;

    const getSelectedCompany = (companyId: string) => {
        const selectedCompanyArr = companyMultiCidn?.data?.data?.find((item) => item.cidn === companyId);
        const selectedCompanyName = selectedCompanyArr && selectedCompanyArr.name;
        return selectedCompanyName;
    }


    const resetSubmittedBy = (companyId: string) => {
        const updatedFilter: ISelectedFilters = {
            searchText: filtersFromState.searchText,
            status: filtersFromState.status,
            assignedTo: filtersFromState.assignedTo,
            dates: filtersFromState.dates,
            selectedDateInput: filtersFromState.selectedDateInput,
            submittedBy: [],
        };
        dispatch(updateSelectedFilters(updatedFilter));
        dispatch(loadCasesFilterUplift(updatedFilter, companyId));
    }

    const companyOptionClickHandler = (event) => {
        const selectedCompanyValue: string = event.currentTarget.id;
        const selectedCompanyName = getSelectedCompany(selectedCompanyValue);
        if (selectedCompanyName) {
            if (props.resetSubmittedByOnChange) {
                resetSubmittedBy(selectedCompanyValue);
            }
            setSelectedCompanyId(selectedCompanyValue);
            props.updateCompanyid(selectedCompanyValue);
            dispatch(setSelectedCidnGlobally(selectedCompanyValue))
            Application.tracker.trackLink(Components.casesListComponent,
                Links.companyDropdown(selectedCompanyName));
        }
    }

    const renderCompanyDropdown = () => {
        return (
            <React.Fragment>
                {props.addColumnAndSpacing ? (
                    <Column cols={3} vxs={12}>
                        <Spacing bottom="spacing2x">
                            <ShowCompanyDropdown
                                companyData={companyMultiCidn.data}
                                companyOptionClickHandler={companyOptionClickHandler}
                                selectedCompanyId={selectedCompanyId}
                                showUpliftedDropdown={props.showUpliftedDropdown}
                            />
                        </Spacing>
                    </Column>
                ) : (
                    <ShowCompanyDropdown
                        companyData={companyMultiCidn.data}
                        companyOptionClickHandler={companyOptionClickHandler}
                        selectedCompanyId={selectedCompanyId}
                        showUpliftedDropdown={props.showUpliftedDropdown}
                    />
                )}
            </React.Fragment>
        );
    };

    useEffect(() => {
        if (isCompanyDropDownShow
            && requestFinished(companyMultiCidn)) {
            const selectedCompanyIdValue = companyMultiCidn?.data?.data[0]?.cidn;
            if (!selectedCompanyId) {
                setSelectedCompanyId(selectedCompanyIdValue)
                dispatch(setSelectedCidnGlobally(selectedCompanyIdValue))
            }
        }
    }, [isCompanyDropDownShow]);
    return (
        isCompanyDropDownShow  && renderCompanyDropdown()
    )
}
